import React, { Component } from "react"
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18n from "../../i18n";
import * as rk from "../../localization/resourceKeys";
import * as T from "../../redux/constants";
import customInputComponent from '../../forms/customInputBronson';
import { ccpaFormValidations } from '../../utils/validations';

class UpdateName extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditName: false,
    }
  }

  componentDidUpdate() {
    ccpaFormValidations();
  }

  validate() {
    let returnValue = Yup.object().shape({
      firstName: Yup.string()
        .required(i18n.t(rk.CCPA_FORM_ERROR.FIRST_NAME_ERROR, { fieldName: "First Name" }))
        .matches(/^[a-zA-Z '-]*$/, { message: i18n.t(rk.CCPA_FORM_ERROR.FIRST_NAME_ERROR) })
        .max(40, i18n.t(rk.CCPA_FORM_ERROR.FIRST_NAME_ERROR)),
      middleInitial: Yup.string()
        .matches(/^[a-zA-Z]*$/, { message: i18n.t(rk.CCPA_FORM_ERROR.MIDDLE_NAME_ERROR) })
        .max(1, i18n.t(rk.CCPA_FORM_ERROR.MIDDLE_NAME_ERROR, { fieldName: "Middile Initial" })),
      lastName: Yup.string()
        .required(i18n.t(rk.CCPA_FORM_ERROR.LAST_NAME_ERROR, { fieldName: "Last Name" }))
        .matches(/^[a-zA-Z '-]*$/, { message: i18n.t(rk.CCPA_FORM_ERROR.LAST_NAME_ERROR) })
        .max(40, i18n.t(rk.CCPA_FORM_ERROR.LAST_NAME_ERROR)),
    })
    return returnValue;
  }

  render() {
    return (
      <div className={`right-to-correct-row ${this.state.isEditName && "update-name"}`}>
        {this.state.isEditName ? (
          <div>
            <div className="u-m">
              {this.props.correctedNameState.isCorrectedName ? (
                <div className="row-container">
                  <div className="pending-changes-data">
                    <div className="submission-pending-left-container">
                      <div className="u-mb-xsmall">
                        <span className='right-to-correct-input-label'>{i18n.t(rk.COMMON.FIRST_NAME)}: </span>{this.props.correctedNameState.firstName}
                      </div>
                      {this.props.correctedNameState.middleInitial && (
                        <div className="u-mb-xsmall">
                          <span className='right-to-correct-input-label'>{i18n.t(rk.COMMON.MIDDLE_NAME)}: </span>{this.props.correctedNameState.middleInitial}
                        </div>
                      )}
                      <div className="u-mb-xsmall">
                        <span className='right-to-correct-input-label'>{i18n.t(rk.COMMON.LAST_NAME)}: </span>{this.props.correctedNameState.lastName}
                      </div>
                    </div>
                  </div>
                  <div className="right-row_content_right">
                    <div className="submission-pending-right-container">
                      <div className="pending-text-container u-float-left u-mr">
                        <i className="c-icon-list__icon  c-icon  c-icon--[semantic-checkmark]  u-text-success" aria-hidden="true" role="img"></i>
                        <span className="submission-pending-text">{i18n.t(rk.DATA_CORRECTION.PENDING_CHANGES)}</span>
                      </div>
                      <button
                        className="cancel-btn c-btn u-m-none u-float-right"
                        onClick={() => {
                          this.props.clearCorrectedName();
                          this.setState({ isEditName: false });
                        }}
                        id="cancel-name-changes-btn"
                        data-testid="cancel-name-changes-btn"
                      >
                        <span className="c-btn__text">
                          {i18n.t(rk.BUTTON.CANCEL)}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Formik
                  initialValues={{
                    firstName: "",
                    middleInitial: "",
                    lastName: "",
                  }}
                  onSubmit={async (values, { setSubmitting }) => {
                    await this.props.saveCorrectedName(values);
                    setSubmitting(false);
                  }}
                  validationSchema={this.validate()}
                >
                  {props => {
                    const { handleSubmit, values } = props;
                    return (
                      <div className="row-container">
                        <div className="o-layout u-m-none">
                          <div className="o-layout__item u-1/1 u-m-none u-p-none">
                            <Field
                              name="firstName"
                              data-testid="firstName"
                              placeHolder={i18n.t(rk.COMMON.FIRST_NAME)}
                              altPlaceholder={(i18n.t(rk.COMMON.FIRST_NAME)).toUpperCase()}
                              type="text"
                              id="firstName"
                              component={customInputComponent}
                              error={props.errors.firstName}
                              helpContent={props.errors.firstName && props.touched.firstName ? props.errors.firstName : ""}
                            />
                          </div>
                          <div className="o-layout__item u-1/1 u-m-none u-p-none">
                            <Field
                              name="middleInitial"
                              data-testid="middleInitial"
                              placeHolder={i18n.t(rk.COMMON.MIDDLE_NAME) + ` (${i18n.t(rk.COMMON.OPTIONAL)})`}
                              altPlaceholder={(i18n.t(rk.COMMON.MIDDLE_NAME)).toUpperCase()}
                              type="text"
                              id="middleInitial"
                              component={customInputComponent}
                              error={props.errors.middleInitial}
                              helpContent={props.errors.middleInitial && props.touched.middleInitial ? props.errors.middleInitial : ""}
                            />
                          </div>
                          <div className="o-layout__item u-1/1 u-m-none u-p-none">
                            <Field
                              name="lastName"
                              data-testid="lastName"
                              placeHolder={i18n.t(rk.COMMON.LAST_NAME)}
                              altPlaceholder={(i18n.t(rk.COMMON.LAST_NAME)).toUpperCase()}
                              type="text"
                              id="lastName"
                              component={customInputComponent}
                              error={props.errors.lastName}
                              helpContent={props.errors.lastName && props.touched.lastName ? props.errors.lastName : ""}
                            />
                          </div>
                        </div>
                        <div className="right-row_content_right">
                          <div className="btn-wrapper">
                            <button
                              className="cancel-btn c-btn u-m-none u-mr"
                              onClick={() => { this.setState({ isEditName: false }) }}
                              id="cancel-update-name-btn"
                              data-testid="cancel-update-name-btn"
                            >
                              <span className="c-btn__text">
                                {i18n.t(rk.BUTTON.CANCEL)}
                              </span>
                            </button>
                            <div className="save-btn-wrapper u-float-right">
                              <button
                                className="u-m-none c-btn"
                                data-testid="save-name-btn"
                                id="save-name-btn"
                                onClick={handleSubmit}
                                disabled={!(values.firstName && values.lastName)}
                              >
                                <span className="c-btn__text">
                                  {i18n.t(rk.BUTTON.SAVE)}
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }}
                </Formik>
              )}
            </div>
          </div>
        ) : (
          <div className="row-container">
            <div className="u-m right-to-correct-input-label">{i18n.t(rk.DATA_CORRECTION.NAME_LABEL)}</div>
            <div className="right-row_content_right">
              <div className="update-btn-wrapper">
                <button
                  className="update-btn c-btn u-m-none u-mr"
                  onClick={() => { this.setState({ isEditName: true }) }}
                  id="update-name-btn"
                  data-testid="update-name-btn"
                >
                  <span className="c-btn__text">
                    {i18n.t(rk.BUTTON.UPDATE)}
                  </span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

UpdateName.propTypes = {
  correctedNameState: PropTypes.object,
  saveCorrectedName: PropTypes.func,
  clearCorrectedName: PropTypes.func,
};

const mapStateToProps = state => ({
  correctedNameState: state.rightToCorrectReducer
});

const mapDispatchToProps = dispatch => ({
  saveCorrectedName: values => dispatch({ type: T.RIGHT_TO_CORRECT.UPDATE_NAME, payload: values }),
  clearCorrectedName: () => dispatch({ type: T.RIGHT_TO_CORRECT.CLEAR_UPDATED_NAME }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(UpdateName));
